// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data

})

export const getData = createAsyncThunk('appUsers/getData', async params => {
  console.log("params>>", params)
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUserData = createAsyncThunk('appUsers/getUserData', async params => {
  // console.log("params>>", params)
  const response = await axios.get(`${process.env.REACT_APP_API_URL}user/adminUserList`, { params })
  console.log("response>>", response)
  return {
    params,
    allData: response.data.data,
    data: response.data.data,
    totalpaid:response.data.totalpaid.length,
    totalPages: response.data.data.length
  }
})

export const getSubUserData = createAsyncThunk('appUsers/getUserData', async params => {
  // console.log("params>>", params)
  const response = await axios.get(`${process.env.REACT_APP_API_URL}user/adminUserList`, { params })
  console.log("response>>", response)
  return {
    params,
    allData: response.data.totalpaid,
    data: response.data.totalpaid,
    totalpaid:response.data.totalpaid.length,
    totalPages: response.data.totalpaid.length
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  console.log("getstate>>>", getState())
  await axios.get(`${process.env.REACT_APP_API_URL}users/deleteUser/${id}`)
  await dispatch(getUserData(getState().users.params))
  // await dispatch(getAllData())
  return id
})

export const verifyUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.get(`${process.env.REACT_APP_API_URL}transaction/verifyUser/${id}`)
  await dispatch(getUserData(getState().users.params))
  // await dispatch(getAllData())
  return id
})

export const appUsersSlice = createSlice({
  name: 'getUserData',
  initialState: {
    data: [],
    totalpaid:1,
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getUserData.fulfilled, (state, action) => {
        state.allData = action.payload.allData
        state.data = action.payload.data
        state.totalpaid = action.payload.totalpaid
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
  }
})

export default appUsersSlice.reducer
